export const lanList = ['tw', 'en'];

export const LANGUAGE_NAME_MAP = {
	tw: '繁體中文',
	en: 'English',
};
